import React from "react";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import InspectList from "../../components/InspectList/InspectList";
import { loadATitleRequestAction } from "../../redux/actions/appTitles";
import { loadAnIssueRequestAction } from "../../redux/actions/appIssues";
import { withRouter } from "react-router-dom";
import "./InspectPage.css";
import Badge from "react-bootstrap/Badge";

class InspectPage extends React.Component {
  constructor(props) {
    super(props);
    this.loadIssue = this.loadIssue.bind(this);
  }

  componentDidMount() {
    const {
      match,
      history,
      titleName,
      loadATitleRequestAction,
      issueName
    } = this.props;

    if (titleName == null) {
      loadATitleRequestAction(match.params.titleID, toast, history);
    }

    if (issueName == null) {
      this.loadIssue();
    }
  }

  loadIssue() {
    const { match, history, loadAnIssueRequestAction } = this.props;
    loadAnIssueRequestAction(match.params.issueID, true, toast, history);
  }

  render() {
    const { issue, match, titleName, title } = this.props;

    const titleAutomate = title != null ? title.automate : 0;
    const meTitleLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/pdf_books`;
    const meLink = `${process.env.REACT_APP_URL_ROOT}titles/${
      match.params.titleID
    }/pdf_books/${match.params.issueID}`;
    const issueName = issue != null ? issue.issue : "";

    return issue == null ? (
      <div>
        <Spinner animation="grow" />
      </div>
    ) : (
      <React.Fragment>
        <Breadcrumb active="true" className="path_container">
          <Breadcrumb.Item href={process.env.REACT_APP_URL_ROOT}>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item href={meTitleLink}>
            {titleName}
            {titleAutomate >= 1 && (
              <Badge variant="warning" className="title_list_item_auto_badge">
                {titleAutomate >= 2 ? "Fit Reading" : "TOC"}
              </Badge>
            )}
          </Breadcrumb.Item>
          <Breadcrumb.Item href={meLink}>{issueName}</Breadcrumb.Item>
        </Breadcrumb>
        <InspectList issue={issue} />
      </React.Fragment>
    );
  }
}

const mapState = (state, ownProps) => {
  const { appTitles, appIssues } = state;
  const { match } = ownProps;

  const titleName =
    appTitles[match.params.titleID] == null
      ? null
      : appTitles[match.params.titleID].name;

  return {
    titleName,
    title: appTitles[match.params.titleID],
    issue: appIssues[match.params.issueID]
  };
};

const mapDispatch = {
  loadATitleRequestAction,
  loadAnIssueRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(withRouter(InspectPage));
